export default function RainbowArc({ className = "", flip = false }) {
  const colors = ["#E0492F", "#F2921D", "#7FBF42", "#2FA39A", "#1B2A4A"];
  return (
    <svg
      viewBox="0 0 600 90"
      fill="none"
      className={className}
      style={flip ? { transform: "scaleY(-1)" } : undefined}
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      {colors.map((c, i) => (
        <path
          key={c}
          d={`M0 ${86 - i * 0} Q 300 ${-60 + i * 18} 600 ${86 - i * 0}`}
          stroke={c}
          strokeWidth="3"
          fill="none"
          transform={`translate(0 ${i * 1.5})`}
        />
      ))}
    </svg>
  );
}
